import { memo } from 'react';
import { LogIn } from 'lucide-react';

interface AuthPromptCardProps {
  readonly onClick: () => void;
}

export const AuthPromptCard = memo(function AuthPromptCard({ onClick }: AuthPromptCardProps) {
  return (
    <button
      onClick={onClick}
      className="w-full mb-4 p-4 rounded-2xl bg-primary/10 border border-primary/20 flex items-center gap-3 hover:bg-primary/15 transition-colors"
    >
      <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
        <LogIn className="w-5 h-5 text-primary" />
      </div>
      <div className="text-left flex-1">
        <p className="font-medium text-foreground">Sign in to sync saves</p>
        <p className="text-sm text-muted-foreground">Your WNTD list will be saved across devices</p>
      </div>
    </button>
  );
});
